import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { BannersType } from "./BannerTypes";

import { Get_Banners, Delete_Banner } from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";

function BannersComp() {
    const Navigate = useNavigate();
    let TableHead = ["BANNER", "TYPE", "CREATED ON", "STATUS", "Actions"];
    const [Banners, setBanners] = useState<BannersType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const getBanners = async () => {
        try {
            const response = await Get_Banners();
            if (response?.data?.status === 1) {
                setBanners(response?.data?.banners);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const DeleteBanner = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_Banner(id);
            if (response?.data?.status === 1) {
                Toast("Banner Deleted Successfully", "success");
                getBanners();
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        getBanners();
    }, []);

    // Function to handle image click and show the modal
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setIsModalVisible(true);
    };

    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    const deleteHandler = (item: BannersType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete Banner?",
            () => DeleteBanner(item.banner_id),
            "Delete"
        );
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="Banner"
            />
            <header>
                <h3>Banners</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/banners/add")}>
                    <FiPlus />
                    Add Banner
                </button>
            </header>
            {/*  <div className={Styles["filter"]}>
                <p>Filter By :</p>
                <select>
                    <option value="0">All</option>
                    <option value="1">Home Banners</option>
                    <option value="2">Promotional Banner</option>
                </select>
            </div> */}
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {Banners.length > 0 ? (
                                Banners?.map((item) => (
                                    <tr key={item?.banner_id}>
                                        <td
                                            onClick={() =>
                                                handleImageClick(item.image_url)
                                            }>
                                            <div className={Styles["banner"]}>
                                                <img
                                                    src={item.image_url}
                                                    alt="banner"
                                                />
                                            </div>
                                        </td>{" "}
                                        <td>
                                            {item?.type == 1
                                                ? "Home Banner"
                                                : "Promotional Banner"}
                                        </td>
                                        <td>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.created_at}
                                            </Moment>
                                        </td>
                                        <td>
                                            {item.status == 1 ? (
                                                <span
                                                    className={
                                                        Styles["Active"]
                                                    }>
                                                    Active
                                                </span>
                                            ) : (
                                                <span
                                                    className={
                                                        Styles["InActive"]
                                                    }>
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/banners/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Banner Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default BannersComp;
